import {
  UserPresence,
  UserPresenceStatus,
} from 'src/graphql/entities/user-presence/user-presence';
import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

type State = {
  byId: Record<string, UserPresence>;
  inFlight: Record<string, boolean>;
  upsertMany: (items: UserPresence[]) => void;
  markInFlight: (ids: string[], v: boolean) => void;
  need: (ids: string[]) => string[];
};

const nowSec = () => Math.floor(Date.now() / 1000);

const ACTIVE_BUFFER_SEC = 5;

const INACTIVE_TTL_SEC = 60;

export const isStalePresence = (p?: UserPresence) => {
  if (!p) return true;
  const n = nowSec();
  if (p.status === UserPresenceStatus.active) return n > p.expiresAt - ACTIVE_BUFFER_SEC;
  return n > p.lastSeen + INACTIVE_TTL_SEC;
};

export const usePresenceStore = create<State>()(
  subscribeWithSelector((set, get) => ({
    byId: {},
    inFlight: {},
    upsertMany: (items) =>
      set((s) => {
        const next = { ...s.byId };
        const ts = Date.now();
        for (const it of items) next[it.userId] = { ...it, updatedAt: ts };
        return { byId: next };
      }),
    markInFlight: (ids, v) =>
      set((s) => {
        const nf = { ...s.inFlight };
        for (const id of ids) nf[id] = v;
        return { inFlight: nf };
      }),
    need: (ids) => {
      const { byId } = get();
      return ids.filter((id) => isStalePresence(byId[id]));
    },
  })),
);
